import React, { Component } from 'react';
import PropTypes from 'prop-types';
import i18n from '../../../i18n';
import styles from '../../../assets/stylesheets/CallsheetInlineStyles';

class CallsheetTable extends Component {
  render() {
    const {
      callTime,
      children,
      name,
      renderForEmail,
      locationContacts,
      wrapTime,
    } = this.props;
    return (
      <table
        border="1"
        style={renderForEmail ? styles.tableEmailWidth : styles.tableFullWidth}
      >
        <thead>
          <tr>
            <th style={styles.locationHeader} colSpan="4">
              <h4>{name}</h4>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th colSpan="4">{i18n.t('callsheet:locationContact')}</th>
          </tr>
          <tr colSpan="4" style={styles.tableCell}>
            <td colSpan="4">{locationContacts}</td>
          </tr>
          <tr>
            <th colSpan="2">{i18n.t('setting:callTime')}</th>
            <th colSpan="2">{i18n.t('setting:wrapTime')}</th>
          </tr>
          <tr>
            <td colSpan="2" style={styles.timeCell}>
              {callTime}
            </td>
            <td colSpan="2" style={styles.timeCell}>
              {wrapTime}
            </td>
          </tr>
          {children}
        </tbody>
      </table>
    )
  }
}

CallsheetTable.propTypes = {
  callTime: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  wrapTime: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  locationContacts: PropTypes.oneOfType([
    PropTypes.objectOf(
      PropTypes.oneOfType([PropTypes.string, PropTypes.array])
    ),
    PropTypes.string,
    PropTypes.array,
  ]).isRequired,
  renderForEmail: PropTypes.bool.isRequired,
};

export default CallsheetTable;
